import React from "react";
import { ChatBoxListState } from "../../controllers/chat-box-list-ui-controller";
import { ChatBoxListActionType } from "../../controllers/chat-box-list-ui-controller/chat-box-list-ui-controller.actions";
import { IntId } from "../../../utils/ids/int-id";
import type {
	AnimationScopeId,
	IChatBoxListAnimationEngine,
	AnimationScope,
} from "./chat-box-list-animation-engine.interface";
import { $Logger } from "../../../../logger";
import type {
	FlipperAnimationScopeId,
	FlipperAnimationScope,
} from "../flip-animation-setup-flow/flip-animation-setup-flow.interface";

export class ChatBoxListAnimationEngine implements IChatBoxListAnimationEngine {
	private animationScopes_: Map<AnimationScopeId, AnimationScope>;
	private currentAnimationScopeId_: AnimationScopeId;
	private ACIGenerator_: IntId;

	constructor() {
		//init currentAnimationScopeId_ to 0.
		this.currentAnimationScopeId_ = 0;
		this.animationScopes_ = new Map();
		this.ACIGenerator_ = new IntId();
	}

	public get currentAnimationScopeId(): AnimationScopeId {
		return this.currentAnimationScopeId_;
	}

	public markANewAnimationScope(
		scope: AnimationScope,
		cblData: {
			action: ChatBoxListActionType;
			state: ChatBoxListState;
		},
	): AnimationScopeId {
		//TODO: create a scope...
		//TODO: generate a new scope id...
		//TODO: store the scope...
		//TODO: return the scope id...
		const scopeId = this.ACIGenerator_.next();
		this.currentAnimationScopeId_ = scopeId;
		this.animationScopes_.set(scopeId, scope);
		console.log(
			"[dongmt][ChatBoxListAnimationEngine][markANewAnimationScope] scope: ",
			scope,
			"cblData: ",
			cblData,
		);
		return scopeId;
	}

	public applyNewFlipperAnimationScope(
		flipperAnimationScope: FlipperAnimationScope,
	): FlipperAnimationScopeId {
		const scopeId = this.ACIGenerator_.next();
		this.currentAnimationScopeId_ = scopeId;
		// this.animationScopes_.set(scopeId, scope);

		//TODO:
		// 1. Lưu lại animation scope này lại.
		// 2. Có thể thêm config là cancel các animation scope trước đó.
		// 3. Có thể thêm config là cancel các animation scope sau đó.
		return scopeId;
	}

	public reactWithComponentDidMount(
		scopeId: AnimationScopeId,
		props: any,
		state: ChatBoxListState,
	): void {
		$Logger.info(
			"reactWithComponentDidMount scopeId: ",
			scopeId,
			" currentScopeId: ",
			this.currentAnimationScopeId,
		);
	}

	public reactWithGetSnapshotBeforeUpdate(
		scopeId: AnimationScopeId,
		prevProps: any,
		props: any,
		prevState: ChatBoxListState,
		state: ChatBoxListState,
	): void {
		$Logger.info(
			"reactWithGetSnapshotBeforeUpdate prevScopeId: ",
			prevProps.state.animationScopeId,
			" currentScopeId: ",
			props.state.animationScopeId,
		);
		// const scope = this.animationScopes_.get(scopeId);
		// if (scope && scope.flow === "add-new-sticker-message") {
		// 	const { stickerDOMRectSnapshot } = scope.scopeData;
		// 	if (stickerDOMRectSnapshot) {
		// 		return stickerDOMRectSnapshot;
		// 	}
		// }
		// return null;
	}

	public reactWithComponentDidUpdate(
		scopeId: AnimationScopeId,
		prevProps: any,
		props: any,
		prevState: ChatBoxListState,
		state: ChatBoxListState,
		snapshot: any,
	): void {
		$Logger.info(
			"reactWithComponentDidUpdate prevScopeId: ",
			prevProps.state.animationScopeId,
			" currentScopeId: ",
			props.state.animationScopeId,
		);
	}

	public reactWithComponentWillUnmount(scopeId: AnimationScopeId): void {
		$Logger.info(
			"reactWithComponentWillUnmount scopeId: ",
			scopeId,
			" currentScopeId: ",
			this.currentAnimationScopeId,
		);
	}

	public AnimationScopedParent(props: any): React.JSX.Element {
		return props.children;
	}

	public AnimationScopedChild(props: any): React.JSX.Element {
		return props.children;
	}
}
